// extracted by mini-css-extract-plugin
export default {"tableData":"style--tableData--8c89e5","right":"style--right--3d0c37","left":"style--left--18dd42","center":"style--center--9880d1"};